// src/routes/AdminRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout';
import OrganizationsList from '../pages/admin/OrganizationsList';
import CreateOrganization from '../pages/admin/CreateOrganization';
import EmployeesList from '../pages/admin/EmployeesList';
import OrganizationDetails from '../pages/admin/OrganizationDetails';
import EmployeeDetail from '../pages/admin/EmployeeDetail';
import AddEmployee from '../pages/admin/AddEmployee';
import RoleEtapesSelector from '../pages/admin/RoleEtapesSelector';
import RoleTable from '../pages/admin/RolesEtapesTable';
import RoleFonctionSelector from '../pages/admin/RoleFonctionSelector';
import RoleTableFunction from '../pages/admin/RoleTableFunction';
import ParametraEtapesAutoCss from '../pages/admin/ajouterFonctionEtapesRoles';
import ParamFonctionnelsOrgas from '../pages/admin/ParamFonctionnelsOrgas';
import UserProfile from '../pages/admin/UserProfile'
import TicketDetailCard from '../pages/admin/PageDetail';
import ParametraModules from '../pages/admin/ajouterModule';
import ParametraValidations from '../pages/admin/ParametraValidations';
import ResetPassword from '../auth/ResetPassword';


const AdminRoutes = () => (
  <Routes>
    <Route path="/" element={<AdminLayout />}>
      <Route index element={<OrganizationsList />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="organisations" element={<OrganizationsList />} />
      <Route path="organisations/create" element={<CreateOrganization />} />
      {/* on passe bien ":id" pour matcher useParams().id */}
      <Route path="organisations/:id" element={<OrganizationDetails />} />

      <Route path="employees" element={<EmployeesList />} />
      {/* idem pour le détail salarié */}
      <Route path="employees/:empId" element={<EmployeeDetail />} />
      <Route path="profile" element={<UserProfile />} />

      <Route path="add-employee" element={<AddEmployee />} />
      <Route path="RoleEtapesSelector" element={<RoleEtapesSelector />} />
      <Route path="RoleFonctionSelector" element={<RoleFonctionSelector />} />
      <Route path="settings/fonctionnel" element={<RoleTableFunction />} />
      <Route path="settings/etapes" element={<RoleTable />} />
      <Route path="settings/Parametresgeneraux" element={<ParametraEtapesAutoCss />} />
      <Route path="settings/ParamFonctionnelsOrgas" element={<ParamFonctionnelsOrgas />} />
      <Route path="/task/:id"  element={<TicketDetailCard />}/>
      <Route path="settings/modules" element={<ParametraModules />} />
      <Route path="settings/validations" element={<ParametraValidations />} />


    </Route>
  </Routes>
);

export default AdminRoutes;
